import { render } from "./HouseDialog.vue?vue&type=template&id=49ff05c7"
import script from "./HouseDialog.vue?vue&type=script&lang=js"
export * from "./HouseDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__